import { TextInput } from 'streamlabs-beaker';
import { Component } from 'vue-property-decorator';
import StudioModalMobile from '@/components/modals/StudioModalMobile.vue';
import EditorBase from '../EditorBase';
import { EModalName } from '@/helpers/modal';
import UserApi from '@/apis/user-api';
import NotificationHelper from '@/helpers/notification';
import { Throttle } from 'lodash-decorators';
import { EAnalyticsEvent } from '@/helpers/analytic';
import { ESocketEvent } from '@/helpers/socket';

@Component({
  components: {
    StudioModalMobile,
    STextInput: TextInput,
  },
})
export default class ConnectStreamlabsModal extends EditorBase {
  get modalName(): string {
    return EModalName.connectStreamlabsModal;
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  onConfirm() {
    const newWindow = window.open();
    UserApi.getStreamlabsAuthUrl().then(response => {
      const url = response.url;

      newWindow.location = url;

      window.addEventListener('message', async (message) => {
        if (message.data && message.data.type === 'callback-success' && message.data.from === 'streamlabs') {
          const user = await UserApi.getMe();
          this.currentUser = user;
          this.$sla.sendEvent(EAnalyticsEvent.streamlabsConnected);

          if (this.userSLWidgetToken) {
            this.onSuccessNotification();
            this.sendSocketEvent(ESocketEvent.updateSLWidgetToken);
            this.hideModal();
          }
        }
      });
    });
  }

  @Throttle(1000, { leading: true, trailing: false })
  onSuccessNotification() {
    NotificationHelper.success('👍  Streamlabs connected!', '.top-nav-notification-container');
  }
}
